import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import tool from '../js/tool'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        scanList: [],
        expressList: [],//快递列表
    },
    getters: {
        scanList: state => {
            return state.scanList;
        },
        expressList: state => {
            return state.expressList;
        },
    },
    mutations: {
        setScanList: function (state, scanList) {
            state.scanList = scanList;
        },
        setExpressList: function (state, expressList) {
            state.expressList = expressList;
        },
    },
    actions: {
        setScanList: function (context, scanList) {
            context.commit('setScanList', scanList);
        },
        getExpressList: function (context, admin_id) {
            axios
                .get("api/get_express_list", {
                    params: {
                        store_id: admin_id,
                    },
                })
                .then((res) => {
                    if (res.data.code == 1001) {
                        let list = res.data.data.map((val) => {
                            val["img"] = tool.expressImage(val["abbreviation"]);
                            val["cname"] =
                                tool.expressCName(val["abbreviation"]) +
                                tool.expressPayTypeName(val["paytype"]);
                            return val;
                        });
                        context.commit('setExpressList', [].concat(list));
                    }
                    else context.commit('setExpressList', []);
                })
                .catch((err) => { 
                    context.commit('setExpressList', []);
                });
        }
    }
});

export default store


// WEBPACK FOOTER //
// ./src/store/store.js